<template>
    <div>
        <div
            v-for="(row, i) in rows"
            v-bind:key="'row-' + i">
            <div class="row">
                <div
                    v-for="(cell, j) in row.Cells"
                    v-bind:key="'cell-' + j"
                    v-bind:class="responsiveClasses.summaryCell">
                    <div v-if="cell.ContainsData && !isLoading">
                        <div class="fw-bold">
                            {{ cell.Label }}
                        </div>
                        <div v-if="cell.Data">
                            {{ cell.Data }}
                        </div>
                        <div
                            v-else
                            class="fst-italic text-body-secondary">
                            {{ noCellDataBodyText }}
                        </div>
                        <hr
                            v-if="i != rows.length - 1 || !isLastNonEmptyCellInRow(row.Cells, j)"
                            v-bind:class="responsiveClasses.cellHr" />
                    </div>
                    <div v-else-if="cell.ContainsData">
                        <div class="fw-bold">
                            {{ cellLoadingHeaderText }}
                        </div>
                        <div>
                            {{ cellLoadingBodyText }}
                        </div>
                    </div>
                </div>
            </div>
            <hr
                v-if="i < rows.length - 1"
                v-bind:class="responsiveClasses.rowHr" />
        </div>
    </div>
</template>

<script>
    import { WIDE_BP } from "./_sharedCapsuleBase";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/projectSummaryCapsule.i18n";
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        summaryCell: {
            col: { xs: 12, [WIDE_BP.name]: "" }
        },
        cellHr: {
            d: { xs: "block", [WIDE_BP.name]: "none" },
            always: "my-2"
        },
        rowHr: {
            d: { xs: "none", [WIDE_BP.name]: "block" },
            always: "my-2"
        }
    };

    export default {
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            rows: { type: Array, required: true },
            isLoading: { type: Boolean, required: true }
        },
        computed: {
            ...mapI18n(KEYS, NAMESPACE),
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            }
        },
        methods: {
            isLastNonEmptyCellInRow(rowCells, cellIndex) {
                let nextIndex = cellIndex + 1;
                while (nextIndex < rowCells.length) {
                    if (rowCells[nextIndex].ContainsData) {
                        return false;
                    }
                    nextIndex++;
                }
                return true;
            }
        }
    };
</script>
